import _ from "lodash";
import Vue from "vue";
import hex2ab from "hex-to-array-buffer";
import cbor from "cbor-js";
import base64url from "base64url";
const Hashes = require("jshashes");

const store = () => window.$store;
const ut = require('../util').default;
const [t, f] = [true, false];

async function util(state, payload) {
  payload = payload.type ? payload : payload[0];
  const methods = {
    decodewm() {
      // payload = {url}
      return ut.decodewm(payload.url, payload.id);
    },
    cbor2str() {
      let ab = hex2ab(payload.cbor.toString());
      return cbor.decode(ab);
    },
    hex2str() {
      var hex = payload.hex.toString();
      var str = "";
      for (var n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
      }
      // console.log({str})
      return str;
    },
    order() {
      // console.log({ payload });
      // payload = {data, prop, direction}
      let orderarr;
      if (!Array.isArray(payload.data)) {
        const orderentries = Object.entries(payload.data);
        orderarr = orderentries.map((x) => {
          let item = { ...x[1], _key: x[0] };
          return item;
        });
      } else {
        orderarr = payload.data;
      }
      // console.log({ orderarr });
      const sorted = _.orderBy(
        orderarr,
        [(x) => x[payload.prop].toLowerCase()],
        payload.direction || "asc"
      );
      // console.log({ sorted });
      return sorted;
    },
    right() {
      // payload = {item, fn, args}
      return Array.isArray(payload.args)
        ? payload.item[payload.fn](...payload.args)
        : payload.item[payload.fn](payload.args);
    },
    filter() {
      // payload = {iter, fn}
      return payload.iter.filter((i) => [payload.fn](i));
    },

    if() {
      // payload = {comparitor, conditions[0,1]}
      switch (payload.comparitor) {
        case "=":
          return payload.conditions[0] === payload.conditions[1];
        case "!=":
          return payload.conditions[0] !== payload.conditions[1];
        case "<":
          return payload.conditions[0] < payload.conditions[1];
        case "<=":
          return payload.conditions[0] <= payload.conditions[1];
        case ">":
          return payload.conditions[0] > payload.conditions[1];
        case ">=":
          return payload.conditions[0] >= payload.conditions[1];
        case "":
          return payload.conditions[0] ? t : f;
        default:
          return f;
      }
    },
    help() {
      return {
        right: { item: Object, fn: String, args: Array },
        filter: { iter: Array, fn: Function },
        if: { comparitor: String, conditions: Array },
        map: { iter: Array, fn: Function },
        set: { obj: Object, prop: String, val: Object },
        delete: { obj: Object, prop: String },
      };
    },
    async map() {
      // payload = {iter, fn}
      let entries = f; // setup for object iteration, defaults to f
      // if pl has fn setup store.dispatch as fn, else create a new Function with body and args
      // TODO allow multiple inputs
      let fn =
        payload.fn.fun && payload.fn.fun.commands
          ? store().dispatch
          : typeof payload.fn !== "function"
          ? new Function("x", payload.fn + "(x)")
          : payload.fn;

      // if iter is an object, get array of entries
      if (!Array.isArray(payload.iter) && typeof payload.iter == "object") {
        entries = t;
        payload.iter = Object.entries(payload.iter);
      }
      // map over iter

      let m = payload.iter.map(async (i) => {
        let item = entries ? i[1] : i;
        let x;

        if (payload.fn.fun && payload.fn.fun.commands) {
          // setup inputs for fn args
          let inputs = {};
          Object.entries(payload.fn.fun.inputs).map((q) => {
            return (inputs[q[0]] = item);
          });
          payload.fn.payload = inputs;
          x = fn("run", payload.fn);
          return (await x) || i;
        } else {
          x = fn(item);
          return x || i;
        }
      });
      if (payload.fn.fun && payload.fn.fun.commands) {
        return Promise.all(m).then((v) => {
          let ret = entries ? Object.fromEntries(v) : v;
          return ret;
        });
      } else {
        let ret = entries ? Object.fromEntries(m) : m;
        return ret;
      }
      // TODO finish mapping with custom functions by getting value of promises in m

      // return payload.iter.map(i => fn(i))
    },
    set() {
      // payload = {obj, prop, val}
      Vue.set(payload.obj, payload.prop, payload.val);
      return payload.obj[payload.prop];
    },
    delete() {
      // payload = {obj, prop}
      if (payload.obj && typeof payload.obj === "object" && payload.prop) {
        Vue.delete(payload.obj, payload.prop);
      }
      return payload.obj && payload.obj[payload.prop];
    },
    hash() {
      // TODO deep sort, normalization, and compression
      // payload {body, count}
      let hex;
      payload.count = (!payload.count && 1) || payload.count;
      let objsort = (obj) => Object.fromEntries(Object.entries(obj).sort());
      for (let x = 0; x < payload.count; x++) {
        hex = new Hashes.SHA256().hex(
          typeof hex === "string" && hex.length > 0
            ? hex
            : typeof payload.body === "object"
            ? JSON.stringify(objsort(payload.body))
            : payload.body
        );
      }
      return hex;
    },
    encode() {
      // todo finish encode and decode conversions for b64, hex, arraybuf, and binary
      const encodetypes = {
        base64url: (x) => "~" + base64url(x),
        // hex: x=> '.' +
      };
      encodetypes[("base64url", payload)];
    },
    decode() {},
    normalize() {
      return payload.str
        .replaceAll(" ", "_")
        .replace(/[^a-zA-Z0-9_-]/g, "")
        .toLowerCase();
    },
    qr() {
      return ut.qr(payload.obj);
    },
    log() {
      // payload = {logname, payload}
      console.log(payload.logname, payload.payload || "");
      return payload.logname;
    },
    datatype() {
      // payload = {value}
      return typeof payload.value;
    },
    isjson() {
      // payload = {value}
      try {
        JSON.parse(payload.value);
        return true;
      } catch (e) {
        return false;
      }
    },
    parsejson() {
      // payload = {value, fallback}
      try {
        return JSON.parse(payload.value);
      } catch (e) {
        return payload.fallback || null;
      }
    },
    // decode(){}
  };
  return methods[payload.type]();
}

export { util };

